<template>
	<div class="ld-panel-title">
		<router-link to="/hosts" class="back-btn"><span></span>实例详情</router-link>
	</div>
	<div class="ld-panel-main">
		<div :class="hostData.instance_type == 1 ? 'main-section' : ''">
			<ul class="tab-rewrite" v-if="hostData.instance_type == 1">
				<li v-for="(item, index) in typeOptions" :key="index" @click="typeChange(index,item.key)" :class="{ 'active': selectedType === index }">{{item.text}}</li>
			</ul>
			<div class="tab-main">
				<el-descriptions title="基本信息" :column="4" border>
					<el-descriptions-item label="实例ID">{{detailData.instance_id}}</el-descriptions-item>
					<el-descriptions-item label="端口">{{detailData.port}}</el-descriptions-item>
					<el-descriptions-item label="实例类型"><el-tag type="success">{{detailData.instance_type_name}}</el-tag></el-descriptions-item>
					<el-descriptions-item label="IP">{{detailData.ip}}</el-descriptions-item>
					<el-descriptions-item label="实例名称">{{detailData.instance_name}}</el-descriptions-item>
					<el-descriptions-item label="最大内存淘汰策略">allkeys-lru</el-descriptions-item>
					<el-descriptions-item label="状态"><el-tag>{{detailData.readable_status}}</el-tag></el-descriptions-item>
					<el-descriptions-item label="密码">
						{{passFlag == true ? detailData.instance_password : password}}
						<span class="pass" @click="passChange">
							<el-icon>
								<View v-if="passFlag == false" />
								<Hide v-else /> 
							</el-icon>
						</span>
					</el-descriptions-item>
					<el-descriptions-item label="开通时间">{{detailData.create_time}}</el-descriptions-item>
					<!-- <el-descriptions-item label="外网连接地址" v-if="detailData.enable_public_network == 2">
						<span v-if="detailData.remote_domain_name !== ''">{{detailData.remote_domain_name}}:{{detailData.remote_port}}</span>
						<el-tag type="info" v-else>未开通</el-tag>
					</el-descriptions-item> -->
				</el-descriptions>
				<el-descriptions title="配置信息" :column="3" border>
					<el-descriptions-item label="实例规格">{{hostData.spec}}</el-descriptions-item>
					<el-descriptions-item label="公网带宽">{{hostData.bandwidth}}Mbps</el-descriptions-item>
					<el-descriptions-item label="系统版本">{{hostData.version}}</el-descriptions-item>
				</el-descriptions>
				<div class="total-main">
					<div v-loading="loading" class="section" id="chart_cpu"></div>
					<div v-loading="loading" class="section" id="chart_memory"></div>
					<div v-loading="loading" class="section" id="chart_connect"></div>
					<div v-loading="loading" class="section" id="chart_cache"></div>
					<div v-loading="loading" class="section" id="chart_netRecv"></div>
					<div v-loading="loading" class="section" id="chart_netSend"></div>
					<div v-loading="loading" class="section" id="chart_oper"></div>
					<div v-loading="loading" class="section" id="chart_redis"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted,onUnmounted,shallowRef } from 'vue';
	import { useRouter } from 'vue-router';
	import { View,Hide } from '@element-plus/icons-vue'
	import { fetchDetail,statistics } from '@/api/host';
	import * as echarts from "echarts";
	
	const router = useRouter();
	const selectedType = ref(0);
	const instance_id = ref('');
	const password = ref('******');
	const passFlag = ref(false);
	const loading = ref(true)
	const detailData = ref('');
	const hostData = ref('');
	const congData = ref('');
	const hostStatistics = ref('');
	const slaveStatistics = ref('');
	const timeData = ref('');
	const cpuChart = ref('');
	const memoryChart = ref('');
	const storageChart = ref('');
	const connectChart = ref('');
	const cacheChart = ref('');
	const netRecvChart = ref('');
	const netSendChart = ref('');
	const operChart = ref('');
	const redisChart = ref('');
	const pagination = reactive({page: 1,size: 30});
	const typeOptions = reactive([
		{
			key: '0',
			text: '主实例'
		},
		{
			key: '1',
			text: '从实例'
		}
	]);
	
	const fetchDetailF = () => {
		const param = {
			'instance_id':instance_id.value
		}
		fetchDetail(param).then((res) => {
			hostData.value = res.data;
			if(hostData.value.instance_type == 1){
				congData.value = res.data.slave_hosts[0];
			}
			detailData.value = res.data;
			loading.value = false;
			statisticsF()
		})
	};
	const statisticsF = () => {
		const param = {
			'page':pagination.page,
			'size':pagination.size,
			'instance_id':instance_id.value
		}
		statistics(param).then((res) => {
			hostStatistics.value = res.data.list;
			if(hostData.value.instance_type == 1){
				slaveStatistics.value = res.data.slave_list[0].list;
			}
			statisticsFun(res.data.list)
		})
	};
	const typeChange = (key,value) => {
		selectedType.value = key;
		switch(value)
		{
			case '0':
				detailData.value = hostData.value;
				statisticsFun(hostStatistics.value)
			break;
			case '1':
				detailData.value = congData.value;
				statisticsFun(slaveStatistics.value)
			break;
		}
	};
	const passChange = () => {
		passFlag.value = !passFlag.value;
	}
	
	const chartCpuInstance = shallowRef(null);
	const chartMemoryInstance = shallowRef(null);
	const chartConnectInstance = shallowRef(null);
	const chartCacheInstance = shallowRef(null);
	const chartNetRecvInstance = shallowRef(null);
	const chartNetSendInstance = shallowRef(null);
	const chartOperInstance = shallowRef(null);
	const chartRedisInstance = shallowRef(null);
	const statisticsFun = (data) => {
		timeData.value = data.map(item => item.create_time);
		connectChart.value = data.map(item => parseInt(item.active_connections));
		cacheChart.value = data.map(item => parseInt(item.cache_hit_rate));  
		cpuChart.value = data.map(item => item.cpu_usage);
		memoryChart.value = data.map(item => item.memory_usage);
		netRecvChart.value = data.map(item => item.network_recv);
		netSendChart.value = data.map(item => item.network_send);
		operChart.value = data.map(item => item.operations_per_sec);
		redisChart.value = data.map(item => item.memcache_used_memory);      
		storageChart.value = data.map(item => item.storage_space);
		cpuChartF();
		memoryChartF();
		connectChartF();
		cacheChartF();
		netRecvChartF();
		netSendChartF();
		operChartF();
		redisChartF();
	}
	const cpuChartF = () => {
		const chart1 = document.getElementById("chart_cpu")
		chart1.removeAttribute('_echarts_instance_')
		chartCpuInstance.value = echarts.init(chart1);
		chartCpuInstance.value.setOption({
			title : {
				text: "CPU使用率",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'CPU使用率',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: cpuChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartCpuInstance.value.resize();
		});
	};
	const memoryChartF = () => {
		const chart1 = document.getElementById("chart_memory")
		chart1.removeAttribute('_echarts_instance_')
		chartMemoryInstance.value = echarts.init(chart1);
		chartMemoryInstance.value.setOption({
			title : {
				text: "内存使用率",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'内存使用率',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: memoryChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartMemoryInstance.value.resize();
		});
	};
	const connectChartF = () => {
		const chart1 = document.getElementById("chart_connect")
		chart1.removeAttribute('_echarts_instance_')
		chartConnectInstance.value = echarts.init(chart1);
		chartConnectInstance.value.setOption({
			title : {
				text: "活跃连接数",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'活跃连接数',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: connectChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartConnectInstance.value.resize();
		});
	};
	const cacheChartF = () => {
		const chart1 = document.getElementById("chart_cache")
		chart1.removeAttribute('_echarts_instance_')
		chartCacheInstance.value = echarts.init(chart1);
		chartCacheInstance.value.setOption({
			title : {
				text: "缓存命中率",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'缓存命中率',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: cacheChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartCacheInstance.value.resize();
		});
	};
	const netRecvChartF = () => {
		const chart1 = document.getElementById("chart_netRecv")
		chart1.removeAttribute('_echarts_instance_')
		chartNetRecvInstance.value = echarts.init(chart1);
		chartNetRecvInstance.value.setOption({
			title : {
				text: "网络接收速率",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'网络接收速率',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: netRecvChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartNetRecvInstance.value.resize();
		});
	};
	const netSendChartF = () => {
		const chart1 = document.getElementById("chart_netSend")
		chart1.removeAttribute('_echarts_instance_')
		chartNetSendInstance.value = echarts.init(chart1);
		chartNetSendInstance.value.setOption({
			title : {
				text: "网络发送速率",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'网络发送速率',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: netSendChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartNetSendInstance.value.resize();
		});
	};
	const operChartF = () => {
		const chart1 = document.getElementById("chart_oper")
		chart1.removeAttribute('_echarts_instance_')
		chartOperInstance.value = echarts.init(chart1);
		chartOperInstance.value.setOption({
			title : {
				text: "每秒请求数",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'每秒请求数',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: operChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartOperInstance.value.resize();
		});
	};
	const redisChartF = () => {
		const chart1 = document.getElementById("chart_redis")
		chart1.removeAttribute('_echarts_instance_')
		chartRedisInstance.value = echarts.init(chart1);
		chartRedisInstance.value.setOption({
			title : {
				text: "Memcached内存使用量",
				textStyle: {
					fontSize: '14',
					fontWeight: 'normal'
				}
			},
			tooltip: {
				trigger: 'axis'
			},
			grid: {
				left: '20',
				right: '10',
				bottom: '5',
				containLabel: true,
				borderColor: '#edf1f2',
				borderWidth: 1
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				axisLine: {
					lineStyle: {
						color: '#d4d7d9',
						width: 1,
						type: 'solid'
					},
					color: '#333',
				},
				axisLabel: {
					textStyle: {
						fontsize: 12,
						color: '#262829'
					},
					formatter: function (val) {
						if (val) {
							if (val.indexOf(' ') === -1) {
								return val;
							} else {
								return val.split(' ').join("\n");
							}
						}
					}
				},
				data: timeData.value
			},
			yAxis: {
				name:'',
				nameTextStyle: {
					color: "#aaa",
					nameLocation: "start",
				},
				type: 'value',
				min: 0,
				axisLine: {
					show: false,
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				},
				axisLabel: {
					textStyle: {
						fontsize: 14,
						color: '#666'
					}
				},
				splitLine: {
					lineStyle: {
						color: '#edf1f2',
						width: 1,
						type: 'solid'
					}
				}
			},
			series: [{
				name:'Memcached内存使用量',
				type:'line',
				symbol: 'circle',
				showSymbol: false,
				smooth: true,
				itemStyle: {
					normal: {
						width: 1,
						color:"#29cc7a",
					}
				},
				areaStyle: {
					normal: {
						color:'rgba(41, 204, 122, .32)'
					}
				},
				data: redisChart.value
			}]
		})
		window.addEventListener("resize", function() {
			chartRedisInstance.value.resize();
		});
	};
	
	onMounted(() => {
		if(router.currentRoute.value.query){
			instance_id.value = router.currentRoute.value.query.id
		}
		fetchDetailF()
	});
	onUnmounted(() => {
		chartCpuInstance.value && chartCpuInstance.value.dispose();
		chartMemoryInstance.value && chartMemoryInstance.value.dispose();
		chartConnectInstance.value && chartConnectInstance.value.dispose();
		chartCacheInstance.value && chartCacheInstance.value.dispose();
		chartNetRecvInstance.value && chartNetRecvInstance.value.dispose();
		chartNetSendInstance.value && chartNetSendInstance.value.dispose();
		chartOperInstance.value && chartOperInstance.value.dispose();
		chartRedisInstance.value && chartRedisInstance.value.dispose();
	})
</script>

<style lang="scss" scoped>
	.main-section{
		border: 1px solid #ddd; 
		border-radius: 4px;
		.tab-main{margin:24px}
	}
	.pass{cursor: pointer;}
	.total-main{
		margin-left: -2%;
		margin-top: 20px;
		overflow: hidden;
		.section{
			float: left;
			border: 1px solid #eee;
			border-radius: 10px;
			width: 48%;
			height: 340px;
			padding: 10px;
			margin: 0 0 20px 2%;
		}
		.full{float: none;clear: both; width: 98%;}
	}
	::v-deep(.el-descriptions__label) {width: 140px;}
</style>